import React from 'react';

const s = {
  page: {
    minHeight: '100vh',
    background: '#0f0f12',
    color: '#fff',
    fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Text', system-ui, sans-serif",
    padding: '0 0 60px',
  },
  header: {
    background: 'rgba(15,15,18,.9)',
    backdropFilter: 'blur(16px)',
    borderBottom: '1px solid rgba(255,255,255,.08)',
    padding: '16px 24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'sticky',
    top: 0,
    zIndex: 50,
  },
  logo: {
    fontSize: 20,
    fontWeight: 900,
    letterSpacing: 1,
    color: '#fff',
    WebkitTextStroke: '1.5px #00ff99',
    textShadow: '0 0 10px rgba(0,255,136,.4)',
    textDecoration: 'none',
  },
  backBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    color: 'rgba(255,255,255,.5)',
    textDecoration: 'none',
    fontSize: 14,
    fontWeight: 600,
    padding: '8px 14px',
    borderRadius: 10,
    border: '1px solid rgba(255,255,255,.1)',
    background: 'rgba(255,255,255,.04)',
  },
  wrap: {
    maxWidth: 720,
    margin: '0 auto',
    padding: '40px 24px',
  },
  badge: {
    display: 'inline-block',
    background: 'linear-gradient(135deg,#00ff99,#00e5ff)',
    color: '#000',
    fontSize: 11,
    fontWeight: 800,
    padding: '4px 12px',
    borderRadius: 20,
    letterSpacing: .5,
    textTransform: 'uppercase',
    marginBottom: 16,
  },
  title: {
    fontSize: 32,
    fontWeight: 900,
    color: '#fff',
    margin: '0 0 8px',
    lineHeight: 1.1,
  },
  meta: {
    fontSize: 13,
    color: 'rgba(255,255,255,.4)',
    margin: '0 0 40px',
    fontWeight: 500,
  },
  divider: {
    height: 1,
    background: 'rgba(255,255,255,.07)',
    margin: '32px 0',
  },
  section: {
    marginBottom: 36,
  },
  sectionNum: {
    fontSize: 11,
    fontWeight: 800,
    textTransform: 'uppercase',
    letterSpacing: 1,
    color: '#00ff99',
    marginBottom: 6,
  },
  h2: {
    fontSize: 18,
    fontWeight: 800,
    color: '#fff',
    margin: '0 0 12px',
  },
  h3: {
    fontSize: 15,
    fontWeight: 700,
    color: 'rgba(255,255,255,.9)',
    margin: '16px 0 8px',
  },
  p: {
    fontSize: 15,
    lineHeight: 1.75,
    color: 'rgba(255,255,255,.75)',
    margin: '0 0 12px',
  },
  ul: {
    margin: '8px 0 12px 20px',
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  li: {
    fontSize: 15,
    lineHeight: 1.65,
    color: 'rgba(255,255,255,.75)',
  },
  highlight: {
    background: 'rgba(0,255,136,.06)',
    border: '1px solid rgba(0,255,136,.15)',
    borderRadius: 12,
    padding: '16px 20px',
    marginBottom: 12,
  },
  noSellBox: {
    background: 'rgba(0,255,136,.05)',
    border: '1px solid rgba(0,255,136,.2)',
    borderRadius: 14,
    padding: '18px 20px',
    margin: '16px 0',
    display: 'flex',
    alignItems: 'flex-start',
    gap: 14,
  },
  noSellIcon: {
    fontSize: 22,
    flexShrink: 0,
    lineHeight: 1,
    marginTop: 2,
  },
  dataTable: {
    width: '100%',
    borderCollapse: 'collapse',
    margin: '12px 0',
    fontSize: 14,
  },
  th: {
    textAlign: 'left',
    padding: '10px 14px',
    background: 'rgba(255,255,255,.04)',
    color: 'rgba(255,255,255,.5)',
    fontWeight: 700,
    fontSize: 11,
    textTransform: 'uppercase',
    letterSpacing: .6,
    borderBottom: '1px solid rgba(255,255,255,.07)',
  },
  td: {
    padding: '10px 14px',
    color: 'rgba(255,255,255,.75)',
    borderBottom: '1px solid rgba(255,255,255,.05)',
    lineHeight: 1.5,
    verticalAlign: 'top',
  },
  contactCard: {
    background: 'rgba(255,255,255,.04)',
    border: '1px solid rgba(255,255,255,.09)',
    borderRadius: 16,
    padding: '24px',
    marginTop: 8,
  },
  contactEmail: {
    color: '#00ff99',
    textDecoration: 'none',
    fontWeight: 700,
    fontSize: 15,
  },
  footer: {
    marginTop: 48,
    paddingTop: 24,
    borderTop: '1px solid rgba(255,255,255,.07)',
    display: 'flex',
    flexWrap: 'wrap',
    gap: 16,
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  footerLinks: {
    display: 'flex',
    gap: 20,
    flexWrap: 'wrap',
  },
  footerLink: {
    color: 'rgba(255,255,255,.4)',
    textDecoration: 'none',
    fontSize: 13,
    fontWeight: 600,
  },
  footerText: {
    color: 'rgba(255,255,255,.25)',
    fontSize: 12,
  },
};

export default function PrivacyPolicy() {
  return (
    <div style={s.page}>
      {/* ── Header ── */}
      <header style={s.header}>
        <a href="https://app.tracksyhq.com" style={s.logo}>TRACKSY</a>
        <a href="https://app.tracksyhq.com" style={s.backBtn}>← Back to App</a>
      </header>

      <div style={s.wrap}>
        <div style={s.badge}>Legal</div>
        <h1 style={s.title}>Privacy Policy</h1>
        <p style={s.meta}>Last updated: March 17, 2026 &nbsp;·&nbsp; Effective date: March 17, 2026</p>

        <div style={s.highlight}>
          <p style={{ ...s.p, margin: 0, color: 'rgba(255,255,255,.85)' }}>
            This Privacy Policy explains what information Tracksy collects, why we collect it,
            how we use it, and your rights regarding your data. We are committed to being
            transparent about our practices.
          </p>
        </div>

        <div style={s.noSellBox}>
          <span style={s.noSellIcon}>🔒</span>
          <div>
            <p style={{ ...s.p, margin: '0 0 4px', fontWeight: 700, color: '#fff' }}>
              We do not sell your data.
            </p>
            <p style={{ ...s.p, margin: 0, fontSize: 14 }}>
              We do not sell, rent, or trade your personal information to third parties for
              advertising, marketing, or any other purpose. Your sales data is yours.
            </p>
          </div>
        </div>

        <div style={s.divider} />

        {/* 1. Introduction */}
        <div style={s.section}>
          <div style={s.sectionNum}>Section 1</div>
          <h2 style={s.h2}>Introduction</h2>
          <p style={s.p}>
            Tracksy ("we," "us," or "our") operates the web application at app.tracksyhq.com.
            This Privacy Policy applies to all information collected through the Tracksy service,
            including via our website, Progressive Web App (PWA), and any related communications.
          </p>
          <p style={s.p}>
            By using Tracksy, you agree to the collection and use of your information as
            described in this policy. If you do not agree, please do not use our service.
          </p>
          <p style={s.p}>
            This policy was last updated on March 17, 2026. We will notify you of material
            changes via the email address associated with your account.
          </p>
        </div>

        <div style={s.divider} />

        {/* 2. Information We Collect */}
        <div style={s.section}>
          <div style={s.sectionNum}>Section 2</div>
          <h2 style={s.h2}>Information We Collect</h2>

          <h3 style={s.h3}>2.1 — Account information</h3>
          <p style={s.p}>
            When you create an account, Firebase Authentication collects the following information.
            You may sign in using any email address (with a password) or via Google Sign-In:
          </p>
          <ul style={s.ul}>
            <li style={s.li}>Full name</li>
            <li style={s.li}>Email address</li>
            <li style={s.li}>Profile photo (if signing in via Google)</li>
            <li style={s.li}>Unique account identifier (generated internally by Firebase)</li>
          </ul>
          <p style={s.p}>
            We request only the minimum permissions necessary. If you use Google Sign-In, we do
            not access your Google contacts, calendar, Gmail, or any other Google services.
          </p>

          <h3 style={s.h3}>2.2 — Sales activity data (entered by you)</h3>
          <p style={s.p}>
            The core data in Tracksy is data you choose to enter, including:
          </p>
          <ul style={s.ul}>
            <li style={s.li}>Sales records (deal dates, front gross, back gross, spiffs)</li>
            <li style={s.li}>Daily activity logs (calls, emails, texts, appointments)</li>
            <li style={s.li}>Commission settings and calculation preferences</li>
            <li style={s.li}>Lead and prospect information</li>
            <li style={s.li}>Appointment records</li>
            <li style={s.li}>Voice memo recordings and transcripts</li>
            <li style={s.li}>Goal and target settings</li>
            <li style={s.li}>Profile information (name, dealership, role)</li>
          </ul>

          <h3 style={s.h3}>2.3 — Usage data</h3>
          <p style={s.p}>
            Firebase and Vercel Analytics may collect basic usage data including:
          </p>
          <ul style={s.ul}>
            <li style={s.li}>Login timestamps and session activity</li>
            <li style={s.li}>Feature usage patterns (which tabs and features are used)</li>
            <li style={s.li}>Device type and browser type (for compatibility)</li>
            <li style={s.li}>General geographic region (country/region level only)</li>
          </ul>
          <p style={s.p}>
            This data is used solely to improve the service and diagnose technical issues.
            It is not linked to individually identifiable profiles for advertising purposes.
          </p>

          <h3 style={s.h3}>2.4 — Payment data</h3>
          <p style={s.p}>
            Stripe processes all subscription payments on our behalf. Tracksy never receives,
            stores, or has access to your raw credit card number, CVV, or full bank account details.
            Stripe handles all payment data under PCI DSS compliance standards.
          </p>
          <p style={s.p}>
            We do receive from Stripe: your email address (for matching to your account),
            subscription status, billing period dates, and whether a payment succeeded or failed.
          </p>
        </div>

        <div style={s.divider} />

        {/* 3. How We Use Your Information */}
        <div style={s.section}>
          <div style={s.sectionNum}>Section 3</div>
          <h2 style={s.h2}>How We Use Your Information</h2>

          <table style={s.dataTable}>
            <thead>
              <tr>
                <th style={s.th}>Purpose</th>
                <th style={s.th}>Data used</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={s.td}>Providing the Tracksy service</td>
                <td style={s.td}>Account info, sales data, activity data</td>
              </tr>
              <tr>
                <td style={s.td}>Processing subscription payments</td>
                <td style={s.td}>Email address (sent to Stripe)</td>
              </tr>
              <tr>
                <td style={s.td}>Service-related communications</td>
                <td style={s.td}>Email address (receipts, subscription notices, policy updates)</td>
              </tr>
              <tr>
                <td style={s.td}>Improving the service</td>
                <td style={s.td}>Anonymized usage patterns</td>
              </tr>
              <tr>
                <td style={s.td}>Support and troubleshooting</td>
                <td style={s.td}>Account info, reported issues</td>
              </tr>
            </tbody>
          </table>

          <p style={{ ...s.p, marginTop: 16 }}>
            We do <strong style={{ color: '#fff' }}>not</strong> use your data for:
          </p>
          <ul style={s.ul}>
            <li style={s.li}>Targeted advertising or remarketing</li>
            <li style={s.li}>Selling or licensing to data brokers or marketing companies</li>
            <li style={s.li}>Profiling for purposes unrelated to the Tracksy service</li>
            <li style={s.li}>Training AI or machine learning models with your personal sales data</li>
          </ul>
        </div>

        <div style={s.divider} />

        {/* 4. Data Storage and Security */}
        <div style={s.section}>
          <div style={s.sectionNum}>Section 4</div>
          <h2 style={s.h2}>Data Storage and Security</h2>
          <p style={s.p}>
            All user data is stored in Google Firebase (Firestore) and Firebase Storage, both
            of which operate data centers in the United States. Voice memo recordings are stored
            in Firestore. All other app data (sales, activities, settings) is stored
            in Firestore.
          </p>
          <p style={s.p}>
            Firebase implements industry-standard security measures including encryption at rest
            and in transit (TLS/HTTPS). Access to your data is controlled by Firebase Security Rules,
            which ensure each user can only access their own data.
          </p>
          <p style={s.p}>
            Payment data is stored and protected by Stripe under PCI DSS compliance. Stripe is
            a certified PCI Service Provider Level 1 — the highest available standard for
            payment processors.
          </p>
          <p style={s.p}>
            While we take reasonable steps to protect your data, no security system is
            impenetrable. We cannot guarantee absolute security of data transmitted over the internet.
          </p>
        </div>

        <div style={s.divider} />

        {/* 5. Data Sharing */}
        <div style={s.section}>
          <div style={s.sectionNum}>Section 5</div>
          <h2 style={s.h2}>Data Sharing and Third Parties</h2>
          <p style={s.p}>
            We share your data only with the following service providers, and only to the extent
            necessary to operate Tracksy:
          </p>
          <table style={s.dataTable}>
            <thead>
              <tr>
                <th style={s.th}>Service provider</th>
                <th style={s.th}>Purpose</th>
                <th style={s.th}>Data shared</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={s.td}>Google Firebase</td>
                <td style={s.td}>Database, authentication, file storage</td>
                <td style={s.td}>All app data (stored on your behalf)</td>
              </tr>
              <tr>
                <td style={s.td}>Stripe</td>
                <td style={s.td}>Payment processing</td>
                <td style={s.td}>Email address, subscription metadata</td>
              </tr>
              <tr>
                <td style={s.td}>Vercel</td>
                <td style={s.td}>App hosting and serverless API functions</td>
                <td style={s.td}>Request logs (standard web server logs)</td>
              </tr>
              <tr>
                <td style={s.td}>OpenAI</td>
                <td style={s.td}>AI chatbot (in-app coaching feature)</td>
                <td style={s.td}>Messages you send to the AI chatbot only</td>
              </tr>
            </tbody>
          </table>
          <p style={{ ...s.p, marginTop: 16 }}>
            No other third parties receive your personal data. We do not share with advertisers,
            analytics companies, data brokers, or any party not listed above.
          </p>
          <p style={s.p}>
            We may disclose your data if required by law, court order, or to protect the rights,
            property, or safety of Tracksy or its users.
          </p>
        </div>

        <div style={s.divider} />

        {/* 6. Your Rights */}
        <div style={s.section}>
          <div style={s.sectionNum}>Section 6</div>
          <h2 style={s.h2}>Your Rights and Choices</h2>
          <p style={s.p}>You have the following rights regarding your personal data:</p>
          <ul style={s.ul}>
            <li style={s.li}>
              <strong style={{ color: '#fff' }}>Access:</strong> View all of your sales data,
              activity logs, and account information at any time within the Tracksy app.
            </li>
            <li style={s.li}>
              <strong style={{ color: '#fff' }}>Correction:</strong> Edit or correct your data
              directly within the app at any time.
            </li>
            <li style={s.li}>
              <strong style={{ color: '#fff' }}>Export:</strong> Contact us at tracksysales@gmail.com
              to request a copy of your data in a portable format.
            </li>
            <li style={s.li}>
              <strong style={{ color: '#fff' }}>Deletion:</strong> Contact us at tracksysales@gmail.com
              to request permanent deletion of your account and all associated data. We will process
              deletion requests within 30 days.
            </li>
            <li style={s.li}>
              <strong style={{ color: '#fff' }}>Subscription management:</strong> Cancel your
              subscription at any time through the billing portal in your account settings.
              Cancellation does not automatically delete your data.
            </li>
            <li style={s.li}>
              <strong style={{ color: '#fff' }}>Withdraw consent:</strong> You may stop using
              Tracksy at any time. To withdraw consent for data processing, contact us to request
              account deletion.
            </li>
          </ul>
          <p style={s.p}>
            To exercise any of these rights, email us at{' '}
            <a href="mailto:tracksysales@gmail.com" style={{ color: '#00ff99' }}>tracksysales@gmail.com</a>.
            We will respond within 30 days.
          </p>
        </div>

        <div style={s.divider} />

        {/* 7. Cookies */}
        <div style={s.section}>
          <div style={s.sectionNum}>Section 7</div>
          <h2 style={s.h2}>Cookies and Local Storage</h2>
          <p style={s.p}>
            Tracksy uses browser cookies and local storage for the following purposes:
          </p>
          <ul style={s.ul}>
            <li style={s.li}>
              <strong style={{ color: '#fff' }}>Authentication:</strong> Firebase Auth uses
              cookies to maintain your login session. These are strictly necessary for the app
              to function.
            </li>
            <li style={s.li}>
              <strong style={{ color: '#fff' }}>Performance caching:</strong> Your app data is
              cached in browser local storage to enable fast load times and offline access.
              This data stays on your device and is synced to Firebase when online.
            </li>
          </ul>
          <p style={s.p}>
            We do not use advertising cookies, third-party tracking pixels, or any cookies for
            behavioral advertising. There are no social media tracking scripts or analytics
            that profile you across other websites.
          </p>
        </div>

        <div style={s.divider} />

        {/* 8. Children's Privacy */}
        <div style={s.section}>
          <div style={s.sectionNum}>Section 8</div>
          <h2 style={s.h2}>Children's Privacy</h2>
          <p style={s.p}>
            Tracksy is designed for professional use by adults in the automotive sales industry.
            The service is not intended for, directed at, or marketed to individuals under the
            age of 18.
          </p>
          <p style={s.p}>
            We do not knowingly collect personal information from anyone under 18 years of age.
            If we become aware that we have inadvertently collected data from a minor, we will
            promptly delete it. If you believe we have collected data from a minor, please contact
            us immediately at tracksysales@gmail.com.
          </p>
        </div>

        <div style={s.divider} />

        {/* 9. Changes to Policy */}
        <div style={s.section}>
          <div style={s.sectionNum}>Section 9</div>
          <h2 style={s.h2}>Changes to This Privacy Policy</h2>
          <p style={s.p}>
            We may update this Privacy Policy from time to time. For material changes — those
            that significantly affect how we handle your data or reduce your rights — we will
            notify you by email at least 30 days before the changes take effect.
          </p>
          <p style={s.p}>
            Non-material updates (such as clarifications or minor corrections) may be posted
            without advance notice. The "Last updated" date at the top of this page always
            reflects the most recent revision.
          </p>
          <p style={s.p}>
            Continued use of Tracksy after the effective date of any updated Privacy Policy
            constitutes your acceptance of the revised policy.
          </p>
        </div>

        <div style={s.divider} />

        {/* 10. Contact */}
        <div style={s.section}>
          <div style={s.sectionNum}>Section 10</div>
          <h2 style={s.h2}>Contact Us</h2>
          <p style={s.p}>
            If you have any questions, concerns, or requests regarding this Privacy Policy or
            your personal data, please contact us:
          </p>
          <div style={s.contactCard}>
            <p style={{ ...s.p, margin: '0 0 4px', color: 'rgba(255,255,255,.5)', fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: .8 }}>Tracksy</p>
            <p style={{ ...s.p, margin: '0 0 4px' }}>Frisco, Texas, United States</p>
            <a href="mailto:tracksysales@gmail.com" style={s.contactEmail}>tracksysales@gmail.com</a>
          </div>
          <p style={{ ...s.p, marginTop: 16, fontSize: 13, color: 'rgba(255,255,255,.4)' }}>
            We will respond to all privacy-related inquiries within 30 days.
          </p>
        </div>

        {/* Footer */}
        <div style={s.footer}>
          <div style={s.footerLinks}>
            <a href="/terms" style={s.footerLink}>Terms of Service</a>
            <a href="/support" style={s.footerLink}>Support</a>
            <a href="https://app.tracksyhq.com" style={s.footerLink}>Back to App</a>
          </div>
          <span style={s.footerText}>© 2026 Tracksy. All rights reserved.</span>
        </div>
      </div>
    </div>
  );
}
